import { BaseModel } from '../base.model';

export class ContactGroup extends BaseModel {
  name: string;
}
